export enum MessageCols {
	editDate = 'editDate',
	startDate = 'startDate',
	endDate = 'endDate',
	bo = 'bo',
	fo = 'fo',
	applicatifs = 'applicatifs',
	displayOnce = 'displayOnce',
	displayOnPage = 'displayOnPage',
	blockConnection = 'blockConnection',
	message = 'message',
	version = 'version'
}

export enum MessageNotifications {
	loadActiveMessages = 'loadActiveMessages'
}

export enum MessageFrequency {
	once = 'once',
	always = 'always'
}

export enum MessageCategory {
	Message = 'Message',
	Version = 'Version'
}